import React, { Component } from "react";

// Styles
import "./styles.scss";
import "../../styles.scss";

// Components
import InputDefault from "../../components/Inputs";
import Button from "../../components/Buttons";

// Utils
import keys from "../../utils/keys";
import ValidationUtil from "../../utils/validation";
import { sendOTP, verifyOTP } from "../../redux/actions";
import cx from "classnames";
import { history } from "./../../utils/history";
import { connect } from "react-redux";
import Lottie from 'react-lottie';
import successAnimationData from '../../assets/success.json'
const successOptions = {
    loop: true,
    autoplay: true, 
    animationData: successAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginDetails: {
        phoneNumber: { val: "", isValid: false },
        otp: { val: "", isValid: false },
      },
      isLoginButtonClicked: false,
      showSuccess: false,
      authScreen: "",
      buttonText: "ok",
    };
  }

  componentWillMount() {
    document.addEventListener("deviceready", this.onDeviceReady(), false);
  }

  onDeviceReady() {
    window.firebase.analytics().logEvent("landing-login");
  }

  handleInputChange(key, value, validationType, minLength, maxLength) {
    const currentState = { ...this.state };

    if (ValidationUtil.isValidValue(value)) {
      value = ValidationUtil.isExceedingMaxLength(value, maxLength);
      value = ValidationUtil.getValidatedValue(value, validationType);
    }

    currentState.loginDetails[key] = {
      val: value,
      isValid: ValidationUtil.isValidInput(value, validationType, minLength),
    };

    this.setState(currentState);
  }

  backToMobileScreen() {
    // const currentState = { ...this.state }
    // if(!currentState.isLoginButtonClicked) {
    //     this.setState({isLoginButtonClicked: true});
    // }
    // history.push("/home");
    let newState = { ...this.state };
    newState["authScreen"] = "mobile";
    newState["buttonText"] = "ok";
    this.setState(newState);
  }

  otpActions() {
    if (this.state.authScreen === "otp") {
      this.props.verifyOTP({
        "customer_mobile": this.state.loginDetails.phoneNumber.val,
        "otp": this.state.loginDetails.otp.val
    },(res) => {
      localStorage.setItem('access_token',res.data.access_token)
      let newState = { ...this.state };
      newState["showSuccess"] = true;
      this.setState(newState);
      setTimeout(() => {
        history.push("/home");
      },2200)
      })
      window.firebase.analytics().logEvent("cta-verify-otp");
    } else {
      this.props.sendOTP({
        "customer_mobile": this.state.loginDetails.phoneNumber.val,
        "card_hash": "",
        "keyword": ""
    },(res) => {
        let newState = { ...this.state };
        newState["authScreen"] = "otp";
        newState["buttonText"] = "verify";
        this.setState(newState);
      })
      window.firebase.analytics().logEvent("cta-send-otp");
    }
  }

  handleOnShowPasswordClick() {
    const currentState = { ...this.state };
    currentState.shouldPasswordVisible = !currentState.shouldPasswordVisible;
    console.log("Current state", currentState.shouldPasswordVisible);

    this.setState(currentState);
  }

  render() {
    const { state, props } = this;

    return (
      <div className="screen login">
        {state.showSuccess && (
          <div className="success-gif">
              <Lottie options={successOptions} />
          </div>
        )}
        <div className="main">
          <h2>login first</h2>
          <div className="neighbour-card animated zoomIn">
            <img
              className="back"
              onClick={() => {
                this.backToMobileScreen();
              }}
              src={require("../../assets/back.svg")}
              style={{ opacity: state.authScreen === "otp" ? 1 : 0 }}
            />
            <img className="logo" src={require("../../assets/logo.png")} />
            <div className="details">
              <InputDefault
                className="input-size"
                containerClassName={cx("animated", {
                  zoomOutLeft: state.authScreen === "otp",
                  zoomInLeft: state.authScreen === "mobile",
                })}
                type="text"
                hasLabel
                label="enter your mobile number"
                placeholder={"9000000000"}
                autoComplete="off"
                value={state.loginDetails.phoneNumber.val || ""}
                errorMsg={
                  state.isLoginButtonClicked &&
                  !state.loginDetails.phoneNumber.isValid
                    ? "Enter Email"
                    : ""
                }
                onChange={({ target }) => {
                  this.handleInputChange(
                    keys.inputFieldKeys.PHONE_NUMBER,
                    target.value,
                    keys.validationKeys.DIGITS,
                    1,
                    10
                  );
                }}
              />
              {state.authScreen === "otp" && (
                <InputDefault
                  containerClassName="animated zoomInRight delay-0-5s otp"
                  className="input-size "
                  type="text"
                  hasLabel
                  label="enter 4 digits otp"
                  placeholder={"0000"}
                  autoComplete="off"
                  value={state.loginDetails.otp.val || ""}
                  errorMsg={
                    state.isLoginButtonClicked &&
                    !state.loginDetails.otp.isValid
                      ? "Enter Email"
                      : ""
                  }
                  onChange={({ target }) => {
                    this.handleInputChange(
                      "otp",
                      target.value,
                      keys.validationKeys.DIGITS,
                      1,
                      4
                    );
                  }}
                />
              )}
              <Button
                buttonClassName="w-50 mr2 btn-signin"
                secondary="true"
                medium="true"
                text={state.buttonText}
                onClick={() => this.otpActions()}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({}) => ({});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  sendOTP: (data,callback) => dispatch(sendOTP(data,callback)),
  verifyOTP: (data,callback) => dispatch(verifyOTP(data,callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
